//@ts-check
import React, { useState, useRef, useEffect } from "react"
import { makeStyles, withStyles } from "@material-ui/core/styles"
import FolderIcon from "@material-ui/icons/Folder"
import FolderOpenIcon from "@material-ui/icons/FolderOpen"
import DescriptionIcon from "@material-ui/icons/Description"

//@ts-ignore
import _ from "lodash"
import clsx from "clsx"
import eyuiTheme from "../theme"
import { useTranslation } from "react-i18next"
import Button from "./button"

const formatFilename = require("../utils/formats").formatFilename

const CONSTS = require("shared/consts")

const fileSymbol = "file" //Symbol("file")

const iconStyling = {
  root: {
    color: eyuiTheme.palette.primary.lighter,
  },
}

const StyledFolderIcon = withStyles(iconStyling)(FolderIcon)
const StyledFolderOpenIcon = withStyles(iconStyling)(FolderOpenIcon)
const StyledDescriptionIcon = withStyles(iconStyling)(DescriptionIcon)


/**
 * @param object {{
 * files: scr.file[],
 * setFiles: (files:scr.file[])=>void,
 * selectedFilePath:scr.selectedFilePath
 * setSelectedFilePath:scr.setSelectedFilePath
 * }}
 */
export default function FileExplorer({
  files = [],
  setFiles,
  selectedFilePath,
  setSelectedFilePath,
}) {
  const { t } = useTranslation()
  const useStyles = makeStyles(theme => ({
    button: {
      minWidth: 32,
      height: 32,
      padding: 0,
      marginRight: theme.spacing(1),
      color: theme.palette.primary.light,
      //@ts-ignore
      borderColor: theme.palette.primary.lighter,
    },
    fileExplorer: {
      fontSize: "0.75rem",
      display: "inline",
      marginRight: theme.spacing(1),
      fontWeight: "bold",
    },
    uploadDropdownButton: {
      fontSize: "0.75rem",
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      marginRight: theme.spacing(1),
      //@ts-ignore
      borderColor: theme.palette.primary.lighter,
    },
    uploadFileFolder: {
      fontSize: "0.75rem",
      fontWeight: "normal",
      width: "100%",
      justifyContent: "flex-start",
      color: theme.palette.primary.main,
    },
    fileManager: {
      alignItems: "center",
      paddingLeft: theme.spacing(1),
      height: CONSTS.FILE_MANAGER_HEIGHT,
      display: "flex",
      justifyContent: "space-between",
    },
    deleteSweepButton: {
      "&:hover": {
        background: "white !important",
        "& svg": {
          color: "#b9251c",
        },
      },
    },
  }))
  const treeWrapperRef = useRef(null)
  const [timeOfLastAutoScroll, setTimeOfLastAutoScroll] = useState(0)

  useEffect(() => {
    const treeWrapper = treeWrapperRef.current
    if (treeWrapper) {
      const heightOfEntireTree = treeWrapper.scrollHeight
      // scroll to the bottom of the list
      treeWrapper.scrollBy({
        top: heightOfEntireTree,
        behavior: "smooth",
      })
    }
  }, [treeWrapperRef, timeOfLastAutoScroll])

  files = _.sortBy(files, file => {
    return file.fileAddedTimestamp || 0
  })

  /** @type {scr.dir} */
  var dirs = {}
  for (var f of files) {
    var v = f.path.split("/")
    _.set(dirs, v || [""], fileSymbol)
  }

  return (
    <>
     
      <Tree
        dir={dirs}
        selected={selectedFilePath}
        onSelected={setSelectedFilePath}
        treeWrapperRef={treeWrapperRef}
        numberOfExistingFiles={files.length}
        isSubtree={false}
        files={files}
      />
    </>
  )
}

/**
 * @param files {scr.file[]}
 * @returns {scr.dir}
 */
export function prepareFilesArrayForTree(files) {
  /** @type {scr.dir} */
  var dirs = {}
  for (var f of files) {
    var v = f.path.split("/")
    _.set(dirs, v || [""], fileSymbol)
  }
  return dirs
}



  /**
 * @param props {{
 * dir:any,
 * parentsString?:string,
 * onSelected,
 * selected,
 * treeWrapperRef,
 * numberOfExistingFiles,
 * isSubtree,
 * files,
 * }} */
export function Tree(props) {
    var {
        dir,
        parentsString = "",
        onSelected,
        selected,
        treeWrapperRef,
        files = [],
      } = props
    
  const { t } = useTranslation()
  var [openedDirs, setOpenedDirs] = useState({})
  var [on, setOn] = useState()

  const fileNameInput = useRef(null)

  const yellowInRgbProperties = "255, 230, 0"

  // Variables
  const fileFolderBorderWidth = 2

  const useStyles = makeStyles(theme => ({
    treeSection: {
      backgroundColor: "#fff",
      height: `calc(100% - ${CONSTS.FILE_MANAGER_HEIGHT}px)`,
      overflowY: "auto",
    },
    fileWrapper: {
      position: "relative",
      display: "flex",
      justifyContent: "space-between",
    },
    fileOrFolder: {
      fontSize: "0.75rem",
      fontWeight: "normal",
      width: "100%",
      minWidth: 0,
      paddingLeft: theme.spacing(1) - fileFolderBorderWidth,
      paddingRight: 0,
      justifyContent: "flex-start",
      borderLeft: `${fileFolderBorderWidth}px solid transparent`,
      "&:hover": {
        textDecoration: "none",
      },
    },
    folderWrapper: {
      width: "100%",
    },
    selectedFile: {
      fontWeight: "bold",
      backgroundColor: `rgba(${yellowInRgbProperties}, 0.1)`,
      borderLeft: `2px solid rgba(${yellowInRgbProperties}, 1)`,
    },
    filenameSection: {
      display: "flex",
      flex: 1,
    },
    filenameWrapper: {
      width: "100%",
    },
    fileExtension: {
      verticalAlign: "bottom",
    },
    rowHoverElements: {
      right: 0,
      top: 0,
      background: "white",
    },
    fileNameInput: {
      borderWidth: "0px 0px 1px",
      outline: "none",
      flexGrow: 1,
      fontSize: "0.75rem",
    },
  }))
  const classes = useStyles({})

  
  const generateFileFolderRow = ({
    originalFileName = "",
    isSelected = false,
    isBeingRenamed = false,
    parentsString = "",
    isFile = false,
    isOpened = false,
    onClick = () => {},
    files = [],
    fileNameInputRef,
  }) => {

    let currentFileName = originalFileName
    if (
      originalFileName === CONSTS.TEMP_FOLDER_LOCATION_MARKER &&
      !isBeingRenamed
    ) {
      // temp folders are only visible when used for creating folders
      return null // hide this row
    }
    let fileNameWithoutExtension = currentFileName
    let fileExtension = ""
    let startIcon
    if (isFile) {
      const fileExtensionStart = currentFileName.lastIndexOf(".")
      fileNameWithoutExtension = currentFileName.slice(0, fileExtensionStart)
      fileExtension = currentFileName.slice(fileExtensionStart)
      startIcon = <StyledDescriptionIcon />
    } else if (isOpened && !isBeingRenamed) {
      startIcon = <StyledFolderOpenIcon />
    } else {
      startIcon = <StyledFolderIcon />
    }
    const iconButton = (
      <Button
        variant="text"
        color="primary"
        className={clsx({
          [classes.fileOrFolder]: true,
          [classes.selectedFile]: isSelected,
        })}
        startIcon={startIcon}
        onClick={onClick}
        staticButton={isBeingRenamed || isSelected}
        wrapperStyling={clsx({[classes.filenameWrapper]: !isBeingRenamed})}
      >
        {isBeingRenamed ||
          formatFilename(
            fileNameWithoutExtension,
            CONSTS.FILE_EXPLORER_FILENAME_LENGTH_DISPLAYED,
          ) + fileExtension}
      </Button>
    )



    return (
      <div
        className={clsx({
          [classes.filenameSection]: true,
          [classes.folderWrapper]: !isFile,
        })}
      >
        {iconButton}
        
      </div>
    )
  }

  return (
    <div className={classes.treeSection} ref={treeWrapperRef}>
      {_.map(dir, (items, dirName) => {
        // if (typeof items == "string") {
        //   return "string:" + items
        // } else {
        var isFolder =
          items != fileSymbol || dirName === CONSTS.TEMP_FOLDER_LOCATION_MARKER
         
        var isFile = !isFolder
       
        var fileURI = parentsString + dirName
        if (isFile) {
          var isSelected = fileURI == selected
          return (
            <div
              onMouseEnter={setOn.bind(null, fileURI)}
              onMouseLeave={setOn.bind(null, null)}
              key={fileURI}
              onClick={() => {
                if (!isSelected) {
                  onSelected(fileURI)
                }
              }}
              style={{
                position: "relative",
                display: "flex",
                flex: 1,
              }}
            >
              {dirName &&
                generateFileFolderRow({
                  isSelected,
                  originalFileName: dirName,
                  parentsString,
                  isFile,
                  isOpened,
                  files,
                  fileNameInputRef: fileNameInput,
                })}
            </div>
          )
        } else if (isFolder) {
          var isOpened = openedDirs[dirName]
          return (
            <div key={fileURI}>
              <div
                onMouseEnter={setOn.bind(null, fileURI)}
                onMouseLeave={setOn.bind(null, null)}
                className={classes.fileWrapper}
              >
            
                {dirName &&
                  generateFileFolderRow({
                    isSelected,
                    originalFileName: dirName,
                    parentsString,
                    isFile,
                    isOpened,
                    files,
                    onClick: () => {
                      openedDirs[dirName] = !isOpened
                      setOpenedDirs({ ...openedDirs })
                    },
                    fileNameInputRef: fileNameInput,
                  })}
              
              </div>
              {isOpened && (
                <div style={{ paddingLeft: 10 }}>
                  <Tree
                    {...props}
                    treeWrapperRef={null}
                    parentsString={parentsString + dirName + "/"}
                    isSubtree={true}
                    // @ts-ignore
                    dir={items}
                  />
                </div>
              )}
            </div>
          )
        }
      })}
    </div>
  )
}
